import {useEffect} from 'react';

import {useDispatch, useSelector} from 'react-redux';

import {LOCAL_STORAGE_CHECKOUT, LOCAL_STORAGE_ORDER_DATA} from 'constants/analytics';
import {
    getExistOrderBeforeToday,
    getOrderLast,
} from 'desktop/pages/success/store/reducers/orderLast/orderLast';
import {getOrderId, getPaymentDetailsId} from 'desktop/pages/success/store/selectors/selectors';
import {AppThunkDispatchType} from 'desktop/store';
import {sendAlgoliaPurchaseEvents} from 'features/purchaseCompleteAlgoliaEvent';
import {purchaseCompleted} from 'features/purchaseCompleteDYEvent/purchaseCompleteDYEvent';
import {useImpactRadius} from 'hooks/analytics/impactRadius/useImpactRadius/useImpactRadius';
import {useGetCustomerData} from 'hooks/getCustomerData/getCustomerData';
import {useGetRouter} from 'hooks/router/router';
import {logWithSentry} from 'libs/sentry/sentry';
import {localStore} from 'libs/storage/storage';

import {useEcommerceAnalytics} from '../useEcommerceAnalytics/useEcommerceAnalytics';

/**
 * Use get order last
 */
export const useGetOrderLast = () => {
    const router = useGetRouter();
    const dispatch = useDispatch<AppThunkDispatchType>();
    const prepareImpactRadius = useImpactRadius({
        getOrderId,
    });
    const {isInsurance, sendEventForInsuranceOrder, sendEventForRegularOrder} =
        useEcommerceAnalytics();
    const id = useSelector(getOrderId);
    const paymentDetailsId = useSelector(getPaymentDetailsId);
    const customer = useGetCustomerData();

    useEffect(() => {
        if (!id) {
            return;
        }
        dispatch(getOrderLast({router}));
        dispatch(getExistOrderBeforeToday(id));
    }, [id]);

    useEffect(() => {
        if (!paymentDetailsId || (customer.status || '').toLowerCase() !== 'fulfilled') {
            return;
        }
        (async () => {
            try {
                await Promise.all([
                    isInsurance ? sendEventForInsuranceOrder() : Promise.resolve(),
                    sendEventForRegularOrder(),
                    prepareImpactRadius(),
                    purchaseCompleted(paymentDetailsId),
                    sendAlgoliaPurchaseEvents(String(customer.id), 'desktop'),
                ]);

                localStore.remove(LOCAL_STORAGE_ORDER_DATA);
                localStore.remove(LOCAL_STORAGE_CHECKOUT);
            } catch (e) {
                logWithSentry(e);
            }
        })();
    }, [paymentDetailsId, customer.status]);
};
